var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1032 35.6033V30.4861C30.1032 25.4592 26.0268 21.3828 21 21.3828C15.9731 21.3828 11.8967 25.4592 11.8967 30.4861V35.6033H30.1032Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.189 18.9248C29.0553 16.0585 29.0553 11.4112 26.189 8.54491C23.3227 5.67858 18.6754 5.67858 15.8091 8.54491C12.9428 11.4112 12.9428 16.0585 15.8091 18.9248C18.6754 21.7911 23.3227 21.7911 26.189 18.9248Z",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.8abd6c6041eb2e638770f5216d3852a9.svg";
export { ForwardRef as ReactComponent };